require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-stretch-your-programming-skills-4-languages-you-should-learn-this-year.json") })
        }
      }, "path---blog-stretch-your-programming-skills-4-languages-you-should-learn-this-year");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-stretch-your-programming-skills-4-languages-you-should-learn-this-year!./.cache/json/blog-stretch-your-programming-skills-4-languages-you-should-learn-this-year.json
// module id = 1079
// module chunks = 231608221292675